import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Composants
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import Users from '../views/Users.vue'
import Admin from '../views/Admin.vue'
import Profile from '../views/Profile.vue'
import Stock from '../views/Stock.vue'
import Planning from '../views/Planning.vue'
import Interventions from '../views/Interventions.vue'
import Caissier from '../views/Caissier.vue'
import Achats from '../views/Achats.vue'
import Layout from '../components/Layout.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      requiresAuth: false,
      public: true
    }
  },
  {
    path: '/recu/:id',
    name: 'RecuDownload',
    component: () => import('@/views/RecuDownload.vue'),
    meta: { 
      requiresAuth: false,
      public: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      requiresAuth: false,
      hideForAuth: true 
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: { 
      requiresAuth: false,
      hideForAuth: true 
    }
  },
  {
    path: '/verify-account',
    name: 'VerifyAccount',
    component: () => import('@/views/VerifyAccount.vue'),
    meta: { 
      requiresAuth: false,
      public: true
    }
  },
  {
    path: '/app',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: to => {
          // Rediriger selon le rôle utilisateur
          const user = store.getters['auth/user']
          if (user && user.role === 'Commercial') {
            return '/planning'
          } else if (user && user.role === 'Technicien') {
            return '/planning'
          } else if (user && user.role === 'SuperAdmin') {
            return '/superadmin'
          }
          return '/dashboard'
        }
      },
      {
        path: '/superadmin',
        name: 'SuperAdmin',
        component: () => import('@/views/SuperAdminDashboard.vue'),
        meta: { 
          title: 'SuperAdmin SaaS',
          icon: 'fas fa-server',
          requiresSuperAdmin: true
        }
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { 
          title: 'Dashboard',
          icon: 'fas fa-tachometer-alt'
        }
      },
      {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: { 
          title: 'Gestion des Utilisateurs',
          icon: 'fas fa-users',
          requiresAdmin: true
        }
      },
      {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        meta: { 
          title: 'Administration',
          icon: 'fas fa-cog',
          requiresAdmin: true
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { 
          title: 'Mon Profil',
          icon: 'fas fa-user'
        }
      },
      {
        path: '/stock',
        name: 'Stock',
        component: Stock,
        meta: { 
          title: 'Gestion de Stock',
          icon: 'fas fa-boxes',
          requiresAdmin: false
        }
      },
      {
        path: '/planning',
        name: 'Planning',
        component: Planning,
        meta: { 
          title: 'Planning & RDV',
          icon: 'fas fa-calendar-alt',
          requiresAdmin: false
        }
      },
      {
        path: '/interventions',
        name: 'Interventions',
        component: Interventions,
        meta: { 
          title: 'Interventions',
          icon: 'fas fa-tools',
          requiresAdmin: false
        }
      },
      {
        path: '/caissier',
        name: 'Caissier',
        component: Caissier,
        meta: { 
          title: 'Espace Financier',
          icon: 'fas fa-cash-register',
          requiresAdmin: false,
          allowedRoles: ['Technicien', 'Financier', 'Admin']
        }
      },
      {
        path: '/clients',
        name: 'Clients',
        component: () => import('@/views/Clients.vue'),
        meta: { 
          title: 'Gestion des Clients',
          icon: 'fas fa-users',
          requiresAdmin: false,
          allowedRoles: ['Admin', 'Commercial', 'Responsable Planning']
        }
      },
      {
        path: '/boms',
        name: 'Boms',
        component: () => import('@/views/Boms.vue'),
        meta: { 
          title: 'Nomenclatures',
          icon: 'fas fa-sitemap',
          requiresAdmin: false
        }
      },
      {
        path: '/production',
        name: 'ProductionOrders',
        component: () => import('@/views/ProductionOrders.vue'),
        meta: { 
          title: 'Ordres de Fabrication',
          icon: 'fas fa-industry',
          requiresAdmin: false
        }
      },
      {
        path: '/workflows',
        name: 'Workflows',
        component: () => import('@/views/Workflows.vue'),
        meta: { 
          title: 'Workflows & Centres',
          icon: 'fas fa-project-diagram',
          requiresAdmin: false
        }
      },
      {
        path: '/quality',
        name: 'QualityPlans',
        component: () => import('@/views/QualityPlans.vue'),
        meta: { 
          title: 'Contrôle Qualité',
          icon: 'fas fa-clipboard-check',
          requiresAdmin: false
        }
      },
      {
        path: '/manufacturing-ai',
        name: 'ManufacturingAI',
        component: () => import('@/views/ManufacturingAI.vue'),
        meta: { 
          title: 'Optimisation IA',
          icon: 'fas fa-brain',
          requiresAdmin: false
        }
      },
      {
        path: '/computer-vision',
        name: 'ComputerVision',
        component: () => import('@/views/ComputerVision.vue'),
        meta: { 
          title: 'Vision Industrielle',
          icon: 'fas fa-eye',
          requiresAdmin: false
        }
      },
      {
        path: '/achats',
        name: 'Achats',
        component: Achats,
        meta: { 
          title: 'Espace Achat',
          icon: 'fas fa-shopping-cart',
          requiresAdmin: false
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      // Rediriger selon le rôle utilisateur pour les 404
      const user = store.getters['auth/user']
      if (user && user.role === 'Commercial') {
        return '/planning'
      } else if (user && user.role === 'Technicien') {
        return '/planning'
      }
      return '/dashboard'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  // Permettre l'accès aux routes publiques sans authentification
  if (to.meta.public) {
    next()
    return
  }

  const isAuthenticated = store.getters['auth/isAuthenticated']
  const user = store.getters['auth/user']

  // Vérifier si l'utilisateur est connecté au démarrage
  if (!isAuthenticated && localStorage.getItem('token')) {
    try {
      await store.dispatch('auth/loadUser')
    } catch (error) {
      console.error('Erreur lors du chargement de l\'utilisateur:', error)
      localStorage.removeItem('token')
    }
  }

  // Rediriger selon le rôle si déjà connecté et tentative d'accès à login
  if (to.meta.hideForAuth && store.getters['auth/isAuthenticated']) {
    const user = store.getters['auth/user']
    if (user && user.role === 'Commercial') {
      next('/planning')
    } else if (user && user.role === 'Technicien') {
      next('/planning')
    } else if (user && user.role === 'SuperAdmin') {
      next('/superadmin')
    } else {
      next('/dashboard')
    }
    return
  }

  // Vérifier l'authentification
  if (to.meta.requiresAuth && !store.getters['auth/isAuthenticated']) {
    next('/login')
    return
  }

  // Vérifier les permissions superadmin
  if (to.meta.requiresSuperAdmin && user && user.role !== 'SuperAdmin') {
    next('/dashboard')
    return
  }

  // Vérifier les permissions admin
  if (to.meta.requiresAdmin && user && user.role !== 'Admin') {
    // Rediriger selon le rôle si accès refusé à une page admin
    if (user.role === 'Commercial') {
      next('/planning')
    } else if (user.role === 'Technicien') {
      next('/planning')
    } else {
      next('/dashboard')
    }
    return
  }

  // Vérifier les rôles autorisés spécifiques
  if (to.meta.allowedRoles && user && !to.meta.allowedRoles.includes(user.role)) {
    // Rediriger selon le rôle si accès refusé
    if (user.role === 'Commercial') {
      next('/planning')
    } else if (user.role === 'Technicien') {
      next('/planning')
    } else {
      next('/dashboard')
    }
    return
  }

  // Empêcher l'accès au Dashboard pour les Commerciaux et Techniciens
  if (to.path === '/dashboard' && user && ['Commercial', 'Technicien'].includes(user.role)) {
    if (user.role === 'Commercial') {
      next('/planning')
    } else if (user.role === 'Technicien') {
      next('/planning')
    }
    return
  }

  // Empêcher l'accès à la Gestion de Stock pour les Techniciens
  if (to.path === '/stock' && user && user.role === 'Technicien') {
    next('/planning')
    return
  }

  next()
})

export default router
